import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

enum EpcotNotificationTypes {
    Info = 'info',
    Error = 'error',
    Success = 'success',
    Warning = 'warning',
}

export interface LinkValues {
    href: string;
    link: string;
    target: string;
}

@Component({
    selector: 'ms-epcot-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    imports: [IconCustomComponent],
})
export class EpcotNotificationComponent implements AfterViewChecked, OnChanges {
    private elementRef = inject(ElementRef);

    @Input() notificationType?: string;
    @Input() message?: string | SafeHtml;
    @Input() notificationHeaderTitle?: string;
    @Input() showCloseButton = false;
    @Input() linkValues?: LinkValues;
    @Output() linkClick = new EventEmitter<Event>();
    @Output() closeButtonClick = new EventEmitter<void>();

    notificationInfo: { type: string; icon: string; iconColor: string } = {
        type: 'info',
        icon: 'theme-info-i',
        iconColor: 'info-Icon',
    };

    iconColor: string;

    ngOnChanges(): void {
        switch (this.notificationType) {
            case EpcotNotificationTypes.Info:
                this.notificationInfo = { type: 'info', icon: 'theme-info-i', iconColor: 'info-Icon' };
                break;
            case EpcotNotificationTypes.Error:
                this.notificationInfo = { type: 'error', icon: 'theme-error-i', iconColor: 'error-Icon' };
                break;
            case EpcotNotificationTypes.Success:
                this.notificationInfo = { type: 'success', icon: 'theme-win', iconColor: 'success-Icon' };
                break;
            case EpcotNotificationTypes.Warning:
                this.notificationInfo = { type: 'warning', icon: 'theme-warning', iconColor: 'warning-Icon' };
                break;
        }
    }

    onCloseClick(): void {
        this.closeButtonClick.next();
    }

    ngAfterViewChecked(): void {
        if (this.elementRef.nativeElement.querySelector('#maxstakeSettings')) {
            this.linkClick.emit();
        }
    }

    onLinkClick(): void {
        this.linkClick.emit();
    }
}
